import React, { useRef, useCallback, useEffect, useState } from 'react';
import { View, colors, Heading } from '@fairygodboss/ui';
import { debounce } from 'throttle-debounce';
import { GridColumnWrapper } from '../../../Events/EventLandingPage/components/GridColumnWrapper';
import { useAdvicePage } from '../AdvicePageContext';
import { FeauturedArticle } from './FeautredArticle';
import { FeaturedCommunityDiscussionCard } from './FeaturedCommunityDiscussionCard';

export const FeautredContent = () => {
    const {
        communityDiscussion,
        editorialContent,
        isSm,
        windowWidth,
    } = useAdvicePage();
    const [featuredArticleHeight, setFeaturedArticleHeight] = useState(467);
    const articleRef = useRef();
    const [imgKey, setImgKey] = useState(1);

    const windowResize = useCallback(() => {
        const randomNumber = Math.floor(Math.random() * 1001);
        setImgKey(randomNumber + 1);

        if (articleRef?.current) {
            const rect = articleRef?.current?.getBoundingClientRect();
            if (rect?.height) {
                setFeaturedArticleHeight(rect?.height);
            }
        }
    }, []);

    useEffect(() => {
        windowResize();
        window.addEventListener(
            'resize',
            debounce(100, () => windowResize()),
            { passive: true }
        );
        return () => {
            window.removeEventListener('resize', windowResize);
        };
    }, [windowResize]);

    const featuredDiscussionsLength = communityDiscussion.filter(
        (i) => i?.topic?.featured
    ).length;

    const featuredEditorialLength = editorialContent.filter(
        (i) => i?.topic?.featured
    ).length;

    return (
        <>
            {featuredEditorialLength > 0 ? (
                <GridColumnWrapper
                    display={{ _: 'none', sm: 'inherit' }}
                    color={colors.neutral[100]}
                    bg={colors.neutral[0]}
                    gridAlignment={{ _: 'center', md: 'start' }}
                    gridColumnSpacing={{ _: 12, sm: 9, md: 12, lg: 12 }}
                    pt={{ _: '40px', md: '56px' }}
                    px={{ _: '16px', sm: '0px', md: '24px', lg: '0px' }}
                    pb="32px"
                >
                    <Heading
                        pb={{ _: '24px', md: '48px' }}
                        variant="headingMd"
                        as="h3"
                    >
                        Featured content
                    </Heading>
                    <View
                        display="flex"
                        width="100%"
                        flexDirection={{ _: 'column', md: 'row' }}
                    >
                        <View
                            width={{
                                _: '100%',
                                md:
                                    featuredDiscussionsLength > 1
                                        ? '58%'
                                        : '100%',
                            }}
                        >
                            <FeauturedArticle
                                content={
                                    editorialContent.filter(
                                        (i) => i?.topic?.featured
                                    )?.[0]
                                }
                                ref={articleRef}
                                renderKey={`featured-content-${imgKey}`}
                            />
                        </View>
                        {featuredDiscussionsLength > 1 ? (
                            <View
                                ml={{ _: '0px', md: '24px' }}
                                width={{ _: '100%', md: '41%' }}
                                height={{
                                    sm: 'inherit',
                                    md: `${featuredArticleHeight}px`,
                                }}
                                display="flex"
                                justifyContent="space-between"
                                flexDirection="column"
                            >
                                <FeaturedCommunityDiscussionCard
                                    windowWidth={windowWidth}
                                    fixedHeight={isSm ? '218px' : null}
                                    alignTop
                                    content={
                                        communityDiscussion.filter(
                                            (i) => i?.topic?.featured
                                        )?.[0]
                                    }
                                />
                                <FeaturedCommunityDiscussionCard
                                    windowWidth={windowWidth}
                                    fixedHeight={isSm ? '218px' : null}
                                    content={
                                        communityDiscussion.filter(
                                            (i) => i?.topic?.featured
                                        )?.[1]
                                    }
                                />
                            </View>
                        ) : null}
                    </View>
                </GridColumnWrapper>
            ) : null}
        </>
    );
};

FeautredContent.displayName = 'FeautredContent';
